import { render, staticRenderFns } from "./UpdateInventory.vue?vue&type=template&id=5fa0abf1"
import script from "./UpdateInventory.vue?vue&type=script&lang=js"
export * from "./UpdateInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports